<template>
  <div>
    <unicom-barra-pesquisa-v2
      v-model="valorBarraPesquisa"
      @limpar-campos="limparCampoPesquisa"
      placeholder="Buscar analista..."
    />
    <div class="scroll-linhas mt-3">
      <ColunaPesquisa
        :colunasPesquisa="colunasPesquisaComputed"
        @input-check="inputCheck"
        :idUsuarioUnimedGiu="idUsuarioUnimedGiu"
      />
    </div>
  </div>
</template>

<script>
import ColunaPesquisa from "./ColunaPesquisa";
export default {
  components: {
    ColunaPesquisa
  },
  props: {
    colunasPesquisaProp: {
      type: Array,
      default: () => []
    },
    idUsuarioUnimedGiu: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      valorBarraPesquisa: "",
      colunasPesquisa: [...this.colunasPesquisaProp]
    };
  },
  methods: {
    limparCampoPesquisa() {
      this.valorBarraPesquisa = "";
    },
    inputCheck(arr) {
      this.$emit("input-check", arr);
    },
    normalizeText(str) {
      return str
        .toString()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
    },
    filtroGenerico(queryText, textoDoItem) {
      const hasValue = val => (val != null ? val : "");

      const text = hasValue(this.normalizeText(textoDoItem));
      const query = hasValue(this.normalizeText(queryText));

      return (
        text
          .toString()
          .toLowerCase()
          .indexOf(query.toString().toLowerCase()) > -1
      );
    },
    filtragemDosItems() {
      return this.colunasPesquisa.filter(e => {
        return this.filtroGenerico(this.valorBarraPesquisa, e.nome);
      });
    }
  },
  computed: {
    colunasPesquisaComputed() {
      return this.filtragemDosItems();
    }
  }
};
</script>

<style lang="scss" scoped>
.scroll-linhas {
  height: 240px;
  overflow: auto;

  &::-webkit-scrollbar {
    width: 8px;
    height: 4px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    background: #fff;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
}
</style>
